import './product-details.scss';
import debounce from 'lodash.debounce';

class ProductDetails {
    constructor (element) {
        this.$container = element;
        this.$toggle = this.$container.querySelector('[data-product-details="toggle"]');
        this.$textInner = this.$container.querySelector('[data-product-details="text"]');
        this.$text = this.$textInner ? this.$textInner.closest('.product-details__text') : null;

        if (!this.$toggle || !this.$textInner || !this.$text) {
            return;
        }

        this.init();
    }

    init () {
        this.$toggle.addEventListener('click', () => {
            this.toggleContent();
        });

        this.updateToggleVisibility = this.updateToggleVisibility.bind(this);
        this.updateToggleVisibility();

        window.addEventListener('resize', debounce(this.updateToggleVisibility, 100));

        // Webfonts can change the text height after init, so re-check once they are ready.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(this.updateToggleVisibility);
        }
    }

    updateToggleVisibility () {
        // Overflow can only be measured while collapsed; keep the toggle visible
        // while expanded so the user can still collapse the text again.
        if (this.$toggle.getAttribute('aria-expanded') === 'true') {
            return;
        }

        const hasHiddenText = this.$textInner.scrollHeight > this.$textInner.clientHeight + 1;
        this.$text.classList.toggle('is--truncated', hasHiddenText);
    }

    toggleContent () {
        const isExpanded = this.$toggle.getAttribute('aria-expanded') === 'true';
        const newExpanded = !isExpanded;

        this.$toggle.setAttribute('aria-expanded', newExpanded);
        this.$textInner.classList.toggle('is--expanded', newExpanded);

        const label = newExpanded ? this.$toggle.dataset.labelLess : this.$toggle.dataset.labelMore;
        const $labelSpan = this.$toggle.querySelector('span');
        if ($labelSpan) {
            $labelSpan.textContent = label;
        }
    }
}

export { ProductDetails };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$modules = $context.querySelectorAll('.product-details');
        const productDetailPage = isProductDetailPage; // eslint-disable-line

        $$modules.forEach(($module) => {
            if (!$module.dataset.initializedProductDetails) {
                $module.dataset.initializedProductDetails = 'true';
                const productDetails = new ProductDetails($module);
                $module.productDetails = productDetails;
            }
        });

        if (productDetailPage) {
            window.dataLayer.push({
                event: 'pdp_view',
                pagePath: window.location.pathname,
                eventCategory: 'product_detail_page',
                eventAction: 'pageview',
                eventLabel: window.location.pathname
            });

            console.info('GTM Push:', 'pdp_view', window.location.pathname);
        }
    }
});
